export default __webpack_public_path__ + "static/section-services-3-8e6eabea0b660fa128e1336b6212e292.jpg";